import React, { useState } from 'react'
import { Grid, FormControl, FormLabel, FormControlLabel, RadioGroup, Radio } from '@mui/material'
import { ItemsSelect } from 'components/forms/components/Select/custom'
import { H3 } from 'components/texts'

const destinatario = "academia"

export default function AcademiaTemplate({ register, errors, reset }) {
  const [opcionSeleccionada, setOpcionSeleccionada] = useState('adulto');

  return (
    <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }} mt={4}>

      <Grid item xs={3}>
        <ItemsSelect name={`${destinatario}.id_curso_escolar`} keyValue={"curso_escolar"} register={register} errors={errors} wantToReset={reset} />
      </Grid>

      <Grid item xs={3}>
        <ItemsSelect name={`${destinatario}.id_tipo_actividad`} keyValue={"tipo_actividad"} register={register} errors={errors} />
      </Grid>

      <Grid item xs={3}>
        <ItemsSelect name={`${destinatario}.id_actividades`} keyValue={"actividad"} register={register} errors={errors} wantToReset={reset} searcheable />
      </Grid>

      <Grid item xs={3}>
        <ItemsSelect name={`${destinatario}.id_modalidad_cursos`} keyValue={"modalidad_cursos"} register={register} errors={errors} wantToReset={reset} searcheable />
      </Grid>

      <Grid item xs={2} mt={4}>
        <FormControl>
          <FormLabel >
            <H3>Nivel de Grupo</H3>
          </FormLabel>
          <RadioGroup onChange={({ target }) => setOpcionSeleccionada(target.value)} value={opcionSeleccionada}
            row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group">
            <FormControlLabel value="niño" control={<Radio />} label="Niños" />
            <FormControlLabel value="adulto" control={<Radio />} label="Adultos" />
          </RadioGroup>
        </FormControl>
      </Grid>
      
      <Grid item xs={4} mt={{ xs: 8 }}>
        <ItemsSelect
          key={opcionSeleccionada}
          register={register}
          errors={errors}
          name={`${destinatario}.nivel_grupo_id`}
          keyValue={opcionSeleccionada === 'adulto' ? "nivel_grupo_adulto" : "nivel_grupo_niño"} />
      </Grid>
    </Grid>
  )
}
